'use client'
import { PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { useState, useEffect } from "react";
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";



/**
 * @typedef {import("@prismicio/client").Content.HeroHeadingHighlightedLabelSlice} HeroHeadingHighlightedLabelSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroHeadingHighlightedLabelSlice>} HeroHeadingHighlightedLabelProps
 * @type {import("react").FC<HeroHeadingHighlightedLabelProps>}
 */
const HeroHeadingHighlightedLabel = ({ slice, index, context }) => {
  const { title, main_image, mobile_image } = slice.primary;
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageUrl = isDesktop
    ? main_image?.url
    : mobile_image?.url;

  const hasImage = Boolean(imageUrl);

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="overflow-hidden "
    >
      <div className="max-w-375 w-full mx-auto framing">
        <Breadcrumbs context={context} index={index} textcolor={"text-dark-green"} />
      </div>
      <div className="pt-10 pb-14 min-h-120 flex flex-col justify-center bg-no-repeat bg-top bg-cover bg-dark-green" style={hasImage ? { backgroundImage: `linear-gradient(#003A3399, #003A3399), url(${imageUrl})` } : {}}>
        <div className="max-w-375 w-full framing mx-auto">
          {isFilled.richText(title) && (
            <div className="max-w-142">
            <PrismicRichText
              field={title}
              components={{
                heading1: ({ children }) => (
                  <h1 className="text-white">
                    {children}
                  </h1>
                ),
              }}
            />
          </div>)}
        </div>
      </div>
    </section>
  );
};

export default HeroHeadingHighlightedLabel;
